import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
const AGB = () => {
  const currentYear = new Date().getFullYear();
  return <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="bg-white rounded-2xl shadow-soft p-8 animate-fade-in">
        <h2 className="text-3xl font-bold text-joerg-800 mb-6">Allgemeine Geschäftsbedingungen</h2>
        <p className="text-sm text-joerg-600 mb-6">Stand: {new Date().toLocaleDateString('de-DE', {
          month: 'long',
          year: 'numeric'
        })}</p>
        
        <Tabs defaultValue="general" className="mt-6">
          <TabsList className="grid w-full grid-cols-2 md:grid-cols-4">
            <TabsTrigger value="general">Allgemeines</TabsTrigger>
            <TabsTrigger value="services">Leistungen</TabsTrigger>
            <TabsTrigger value="payment">Vergütung</TabsTrigger>
            <TabsTrigger value="rights">Rechte</TabsTrigger>
          </TabsList>
          
          <TabsContent value="general" className="pt-6">
            <Card>
              <CardHeader>
                <CardTitle>§1 Allgemeine Bestimmungen</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-sm text-joerg-600">
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">1.1 Geltungsbereich</h4>
                  <p className="leading-relaxed">
                    Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Verträge über Coaching- und Beratungsleistungen zwischen Jörg Hörmann Coaching & Consulting, Grimmstr. 15, 91154 Roth, Deutschland (nachfolgend "Jörg Hörmann" oder "Coach") und Verbrauchern im Sinne des § 13 BGB sowie Unternehmern im Sinne des § 14 BGB (nachfolgend "Klient" oder "Sie").
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">1.2 Vertragsgegenstand</h4>
                  <p className="leading-relaxed">
                    Gegenstand des Vertrages ist die Durchführung von persönlichem Coaching, Beratung und Workshops (nachfolgend "Coaching") in den Bereichen Finanzcoaching, persönliche Entwicklung und berufliche Orientierung. Die konkreten Inhalte und der Umfang der Leistungen werden im jeweiligen Coaching-Vertrag oder in der Auftragsbestätigung festgelegt.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">1.3 Vertragsschluss</h4>
                  <p className="leading-relaxed">
                    Der Vertrag kommt zustande, wenn Sie einen Coaching-Termin buchen und Jörg Hörmann Ihre Buchung bestätigt, oder wenn Sie ein Coaching-Paket bestellen und er Ihre Bestellung annimmt. Die Bestätigung erfolgt in der Regel per E-Mail. Mit der Annahme oder Bestätigung Ihrer Buchung oder Bestellung akzeptieren Sie diese AGB.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">1.4 Keine Erfolgsgarantie</h4>
                  <p className="leading-relaxed">
                    Das Coaching stellt eine Dienstleistung dar, bei der sich Jörg Hörmann nach besten Kräften bemüht, Sie bei der Erreichung Ihrer Ziele zu unterstützen. Er kann jedoch keinen bestimmten Erfolg garantieren, da dieser maßgeblich von Ihrer aktiven Mitarbeit abhängt. Das Coaching ersetzt keine medizinische, psychotherapeutische oder rechtliche Beratung.
                  </p>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="services" className="pt-6">
            <Card>
              <CardHeader>
                <CardTitle>§2 Leistungsumfang und Durchführung</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-sm text-joerg-600">
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">2.1 Leistungsumfang</h4>
                  <p className="leading-relaxed">
                    Der genaue Umfang der Coaching-Leistungen wird im jeweiligen Coaching-Vertrag festgelegt. Angeboten werden sowohl Einzelsitzungen ("Flex-Zeit") als auch strukturierte Coaching-Pakete wie "Perspektivwechsel" (3 Sitzungen) oder "Tiefe Veränderung" (6 Sitzungen). Sofern nicht anders vereinbart, beträgt die Dauer einer Standard-Coaching-Sitzung 60 Minuten.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">2.2 Durchführungsort</h4>
                  <p className="leading-relaxed">
                    Das Coaching kann nach Vereinbarung flexibel in verschiedenen Formaten durchgeführt werden:
                    <ul className="list-disc pl-5 mt-2 space-y-1">
                      <li>Online per DSGVO-konformer Videokonferenz</li>
                      <li>Telefonisch</li>
                      <li>In den Coaching-Räumen von Jörg Hörmann</li>
                      <li>In von Ihnen bereitgestellten Räumen (z.B. bei Ihnen zu Hause oder am Arbeitsplatz)</li>
                      <li>Outdoor-Coaching (z.B. am Rothsee oder anderen geeigneten Orten)</li>
                      <li>An besonderen Orten (Museen, Ausstellungen oder andere inspirierende Orte)</li>
                    </ul>
                    Der konkrete Ort und das Format werden vor Beginn des Coachings vereinbart.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">2.3 Terminvereinbarung und -absage</h4>
                  <p className="leading-relaxed">
                    Termine werden nach Verfügbarkeit vereinbart. Sie können einen vereinbarten Termin bis zu 48 Stunden vor dem geplanten Beginn kostenfrei absagen oder verschieben. Bei Absage bis zu 24 Stunden vor dem Termin werden 50% der vereinbarten Vergütung berechnet. Bei späterer Absage oder Nichterscheinen wird die volle Vergütung für die gebuchte Sitzung berechnet, es sei denn, Sie können nachweisen, dass Jörg Hörmann kein oder ein geringerer Schaden entstanden ist.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">2.4 Mitwirkungspflichten</h4>
                  <p className="leading-relaxed">
                    Der Erfolg des Coachings hängt maßgeblich von Ihrer aktiven Mitwirkung ab. Sie verpflichten sich, an den vereinbarten Terminen teilzunehmen und die besprochenen Übungen und Aufgaben nach besten Kräften umzusetzen.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">2.5 Änderungen des Leistungsumfangs</h4>
                  <p className="leading-relaxed">
                    Änderungen oder Erweiterungen des vereinbarten Leistungsumfangs bedürfen einer zusätzlichen Vereinbarung zwischen Ihnen und Jörg Hörmann. Er behält sich vor, die Methodik und den Ablauf des Coachings an Ihre individuellen Bedürfnisse anzupassen, ohne dass dies eine Änderung des Leistungsumfangs darstellt.
                  </p>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="payment" className="pt-6">
            <Card>
              <CardHeader>
                <CardTitle>§3 Vergütung und Zahlungsbedingungen</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-sm text-joerg-600">
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">3.1 Vergütung</h4>
                  <p className="leading-relaxed">
                    Die Vergütung für die Coaching-Leistungen richtet sich nach der jeweils aktuellen Preisliste oder nach individueller Vereinbarung. Bei Verbrauchern verstehen sich alle Preise inklusive der gesetzlichen Mehrwertsteuer. Bei Unternehmern verstehen sich alle Preise zuzüglich der gesetzlichen Mehrwertsteuer.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">3.2 Zahlungsbedingungen</h4>
                  <p className="leading-relaxed">
                    Die konkreten Zahlungsbedingungen werden im jeweiligen Coaching-Vertrag festgelegt. Die Zahlung kann per Überweisung oder über einen vereinbarten, DSGVO-konformen Online-Zahlungsdienst erfolgen.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">3.3 Verzug</h4>
                  <p className="leading-relaxed">
                    Bei Zahlungsverzug können Verzugszinsen in gesetzlicher Höhe sowie Mahngebühren berechnet werden. Jörg Hörmann behält sich vor, bei Zahlungsverzug die weitere Leistungserbringung bis zur vollständigen Bezahlung auszusetzen.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">3.4 Rückerstattung</h4>
                  <p className="leading-relaxed">
                    Bei vorzeitiger Beendigung eines Coaching-Pakets erfolgt eine anteilige Rückerstattung der bereits entrichteten Vergütung, abzüglich der bereits geleisteten Coaching-Stunden. Diese werden zum regulären Einzelstundensatz berechnet.
                  </p>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="rights" className="pt-6">
            <Card>
              <CardHeader>
                <CardTitle>§4 Rechte und Pflichten</CardTitle>
              </CardHeader>
              <CardContent className="space-y-6 text-sm text-joerg-600">
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">4.1 Vertraulichkeit</h4>
                  <p className="leading-relaxed">
                    Jörg Hörmann verpflichtet sich, alle im Rahmen des Coachings bekannt gewordenen persönlichen Informationen und Daten vertraulich zu behandeln und nicht an Dritte weiterzugeben, sofern keine gesetzliche Offenbarungspflicht besteht. Diese Vertraulichkeitsverpflichtung gilt auch über das Ende des Coaching-Verhältnisses hinaus.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">4.2 Datenschutz</h4>
                  <p className="leading-relaxed">
                    Die Verarbeitung personenbezogener Daten erfolgt gemäß der EU-Datenschutz-Grundverordnung (DSGVO) und nur, soweit dies für die Durchführung des Coachings erforderlich ist. Jörg Hörmann ergreift angemessene technische und organisatorische Maßnahmen zum Schutz Ihrer Daten. Nähere Informationen zum Datenschutz finden Sie in der Datenschutzerklärung.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">4.3 Urheberrechte</h4>
                  <p className="leading-relaxed">
                    Alle im Rahmen des Coachings ausgehändigten Unterlagen, Materialien und Medien unterliegen dem Urheberrecht von Jörg Hörmann oder der jeweiligen Rechteinhaber. Sie dürfen diese Materialien ausschließlich für Ihren persönlichen Gebrauch nutzen. Eine Weitergabe an Dritte oder eine kommerzielle Nutzung ist ohne ausdrückliche schriftliche Zustimmung nicht gestattet.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">4.4 Aufzeichnungen</h4>
                  <p className="leading-relaxed">
                    Audio- oder Videoaufzeichnungen der Coaching-Sitzungen sind nur mit vorheriger ausdrücklicher Zustimmung aller Beteiligten gestattet.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">4.5 Widerrufsrecht</h4>
                  <p className="leading-relaxed">
                    Wenn Sie Verbraucher im Sinne des § 13 BGB sind und der Vertrag unter ausschließlicher Verwendung von Fernkommunikationsmitteln abgeschlossen wurde, steht Ihnen ein gesetzliches Widerrufsrecht zu. Informationen zu Ihrem Widerrufsrecht und ein Muster-Widerrufsformular finden Sie in der Widerrufsbelehrung, die Ihnen mit der Vertragsbestätigung zugeht.
                  </p>
                  
                  <p className="leading-relaxed mt-2">
                    Das Widerrufsrecht erlischt bei einem Vertrag zur Erbringung von Dienstleistungen, wenn Jörg Hörmann die Dienstleistung vollständig erbracht hat und mit der Ausführung der Dienstleistung erst begonnen hat, nachdem Sie dazu Ihre ausdrückliche Zustimmung gegeben haben und gleichzeitig Ihre Kenntnis davon bestätigt haben, dass Sie Ihr Widerrufsrecht bei vollständiger Vertragserfüllung verlieren.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">4.6 Kündigung des Vertrags</h4>
                  <p className="leading-relaxed">
                    Bei Coaching-Paketen mit mehreren Sitzungen kann der Vertrag von beiden Seiten aus wichtigem Grund gekündigt werden. Ein wichtiger Grund liegt insbesondere vor, wenn eine Vertrauensbasis für die weitere Zusammenarbeit nicht mehr gegeben ist. Bei vorzeitiger Kündigung durch den Klienten ohne wichtigen Grund besteht Anspruch auf anteilige Rückerstattung bereits geleisteter Zahlungen gemäß Punkt 3.5.
                  </p>
                </div>
              </CardContent>
            </Card>
            
            <Card className="mt-6">
              <CardHeader>
                <CardTitle>§5 Besondere Bestimmungen für Unternehmer</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-sm text-joerg-600">
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">5.1 Geltungsbereich für Unternehmer</h4>
                  <p className="leading-relaxed">
                    Wenn Sie den Vertrag als Unternehmer im Sinne des § 14 BGB abschließen, gelten die folgenden Bestimmungen ergänzend zu den vorgenannten Regelungen.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">5.2 Zahlungsfristen</h4>
                  <p className="leading-relaxed">
                    Für Unternehmer gilt eine Zahlungsfrist von 14 Tagen nach Rechnungsstellung, sofern keine abweichende Vereinbarung getroffen wurde.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">5.3 Kein Widerrufsrecht</h4>
                  <p className="leading-relaxed">
                    Das Widerrufsrecht besteht nicht für Verträge, die von Unternehmern im Sinne des § 14 BGB im Rahmen ihrer gewerblichen oder selbständigen beruflichen Tätigkeit abgeschlossen werden.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">5.4 Haftungsbeschränkung</h4>
                  <p className="leading-relaxed">
                    Bei leicht fahrlässiger Verletzung unwesentlicher Vertragspflichten haftet Jörg Hörmann gegenüber Unternehmern nicht. Im Übrigen ist die Haftung auf den vorhersehbaren, vertragstypischen, unmittelbaren Durchschnittsschaden begrenzt. Dies gilt auch bei leicht fahrlässigen Pflichtverletzungen der gesetzlichen Vertreter oder Erfüllungsgehilfen.
                  </p>
                  <p className="leading-relaxed mt-2">
                    Die vorstehenden Haftungsbeschränkungen betreffen nicht Ansprüche aus Produkthaftung. Weiter gelten die Haftungsbeschränkungen nicht bei zurechenbaren Körper- und Gesundheitsschäden oder bei Verlust des Lebens.
                  </p>
                </div>
              </CardContent>
            </Card>
            
            <Card className="mt-6">
              <CardHeader>
                <CardTitle>§6 Schlussbestimmungen</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4 text-sm text-joerg-600">
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">6.1 Anwendbares Recht</h4>
                  <p className="leading-relaxed">
                    Für diese AGB und alle Rechtsbeziehungen zwischen Ihnen und Jörg Hörmann gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Bei Verbrauchern gilt diese Rechtswahl nur insoweit, als nicht der gewährte Schutz durch zwingende Bestimmungen des Rechts des Staates, in dem der Verbraucher seinen gewöhnlichen Aufenthalt hat, entzogen wird.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">6.2 Gerichtsstand</h4>
                  <p className="leading-relaxed">
                    Sofern Sie keinen allgemeinen Gerichtsstand in Deutschland haben oder Kaufmann sind, ist Gerichtsstand für alle etwaigen Streitigkeiten aus der Geschäftsbeziehung der Sitz von Jörg Hörmann. Zwingende gesetzliche Bestimmungen über ausschließliche Gerichtsstände bleiben unberührt.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">6.3 Salvatorische Klausel</h4>
                  <p className="leading-relaxed">
                    Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so wird dadurch die Wirksamkeit der übrigen Bestimmungen nicht berührt. An die Stelle der unwirksamen Bestimmung tritt eine wirksame Bestimmung, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium text-joerg-700 mb-2">6.4 Änderungen der AGB</h4>
                  <p className="leading-relaxed">
                    Jörg Hörmann behält sich vor, diese AGB jederzeit zu ändern. Die geänderten Bedingungen werden dem Klienten per E-Mail mindestens zwei Wochen vor ihrem Inkrafttreten zugesendet. Widerspricht der Klient der Geltung der neuen AGB nicht innerhalb von zwei Wochen nach Empfang der E-Mail, gelten die geänderten AGB als angenommen.
                  </p>
                </div>
                
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-xs text-gray-500">
                    © {currentYear} Jörg Hörmann Coaching & Consulting. Diese AGB sind urheberrechtlich geschützt.
                  </p>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>;
};
export default AGB;